// Auto-generated from proto definitions. DO NOT EDIT.

export type UserStatus = 'USER_STATUS_UNSPECIFIED' | 'USER_STATUS_ACTIVE' | 'USER_STATUS_INACTIVE' | 'USER_STATUS_SUSPENDED' | 'USER_STATUS_BANNED' | 'USER_STATUS_PENDING' | 'USER_STATUS_DELETED';

export const UserStatusValues = ['USER_STATUS_UNSPECIFIED', 'USER_STATUS_ACTIVE', 'USER_STATUS_INACTIVE', 'USER_STATUS_SUSPENDED', 'USER_STATUS_BANNED', 'USER_STATUS_PENDING', 'USER_STATUS_DELETED'] as const;
